import React, { useEffect, useState } from 'react';
import { archiveAPI } from '../services/api';
import { Loading, EmptyState, Pagination } from '../components/common';
import { formatDate } from '../utils/formatters';
import { CURRENT_YEAR } from '../utils/constants';
import { ArchiveBoxIcon, ClipboardDocumentListIcon, DocumentChartBarIcon } from '@heroicons/react/24/outline';

const Archive = () => {
  const [activeTab, setActiveTab] = useState('tasks');
  const [tasks, setTasks] = useState([]);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [year, setYear] = useState(CURRENT_YEAR);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (activeTab === 'tasks') {
          const response = await archiveAPI.getTasks({ year });
          setTasks(response.data.results || response.data);
        } else {
          const response = await archiveAPI.getReports({ year });
          setReports(response.data.results || response.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [activeTab, year]);

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Arxiv</h1>
          <p className="text-gray-500">Arxivlangan topshiriqlar va hisobotlar</p>
        </div>
        <select className="select w-auto" value={year} onChange={(e) => setYear(parseInt(e.target.value))}>
          {[CURRENT_YEAR, CURRENT_YEAR - 1, CURRENT_YEAR - 2, CURRENT_YEAR - 3].map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>

      {/* Tabs */}
      <div className="card p-0">
        <div className="flex border-b">
          <button
            onClick={() => setActiveTab('tasks')}
            className={`flex-1 py-4 text-center font-medium ${activeTab === 'tasks' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`}
          >
            <ClipboardDocumentListIcon className="w-5 h-5 inline mr-2" />
            Topshiriqlar
          </button>
          <button
            onClick={() => setActiveTab('reports')}
            className={`flex-1 py-4 text-center font-medium ${activeTab === 'reports' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500'}`}
          >
            <DocumentChartBarIcon className="w-5 h-5 inline mr-2" />
            Hisobotlar
          </button>
        </div>

        <div className="p-6">
          {loading ? (
            <Loading />
          ) : activeTab === 'tasks' ? (
            tasks.length > 0 ? (
              <div className="space-y-3">
                {tasks.map((task) => (
                  <div key={task.id} className="p-4 bg-gray-50 rounded-xl">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-medium text-gray-800">{task.title}</h3>
                        <p className="text-sm text-gray-500">{task.organization_name}</p>
                      </div>
                      <div className="text-right">
                        <span className="badge badge-gray">{task.status}</span>
                        <p className="text-xs text-gray-400 mt-1">Arxivlangan: {formatDate(task.archived_at)}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <EmptyState icon={ClipboardDocumentListIcon} title="Arxivlangan topshiriqlar yo'q" />
            )
          ) : (
            reports.length > 0 ? (
              <div className="space-y-3">
                {reports.map((report) => (
                  <div key={report.id} className="p-4 bg-gray-50 rounded-xl">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-medium text-gray-800">{report.title}</h3>
                        <p className="text-sm text-gray-500">{report.organization_name} - {report.period_year}/{report.period_quarter}-chorak</p>
                      </div>
                      <p className="text-xs text-gray-400">Arxivlangan: {formatDate(report.archived_at)}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <EmptyState icon={DocumentChartBarIcon} title="Arxivlangan hisobotlar yo'q" />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Archive;
